module.exports = __webpack_public_path__ + "static/img/SMSscenario3.c03a3fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/SMSscenario3.png
// module id = dJup
// module chunks = 0